var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductInShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E5F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77408 17.9465H8V14.0535H8.77408V17.9465Z",
    fill: "#82CFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5583 14.0535L11.5233 16.877L12.4832 14.0535H13.4998V17.9465H12.7231V16.8824L12.8005 15.0455L11.7865 17.9465H11.2549L10.2435 15.0481L10.3209 16.8824V17.9465H9.54682V14.0535H10.5583Z",
    fill: "#82CFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3961 17.1444H15.0389L14.7808 17.9465H13.9577L15.3562 14.0535H16.0735L17.4798 17.9465H16.6567L16.3961 17.1444ZM15.2479 16.4947H16.1871L15.7149 15.0374L15.2479 16.4947Z",
    fill: "#82CFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7992 17.4545C20.6599 17.6275 20.4629 17.762 20.2084 17.8583C19.9538 17.9528 19.6717 18 19.362 18C19.0369 18 18.7514 17.9269 18.5054 17.7807C18.2611 17.6328 18.0719 17.4189 17.9377 17.139C17.8053 16.8592 17.7373 16.5303 17.7339 16.1524V15.8877C17.7339 15.4991 17.7967 15.1631 17.9222 14.8797C18.0495 14.5945 18.2319 14.377 18.4693 14.2273C18.7084 14.0758 18.9879 14 19.3078 14C19.7534 14 20.1017 14.1105 20.3529 14.3316C20.604 14.5508 20.7528 14.8708 20.7992 15.2914H20.0458C20.0114 15.0686 19.9348 14.9055 19.8162 14.8021C19.6992 14.6988 19.5375 14.6471 19.3311 14.6471C19.0679 14.6471 18.8675 14.7496 18.7299 14.9545C18.5923 15.1595 18.5226 15.4643 18.5209 15.869V16.1176C18.5209 16.5258 18.5957 16.8342 18.7453 17.0428C18.895 17.2513 19.1143 17.3556 19.4033 17.3556C19.694 17.3556 19.9013 17.2914 20.0252 17.1631V16.492H19.3207V15.9011H20.7992V17.4545Z",
    fill: "#82CFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.742 16.2594H22.2557V17.3021H24V17.9465H21.4817V14.0535H23.9948V14.7032H22.2557V15.631H23.742V16.2594Z",
    fill: "#82CFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductInShop);
export default __webpack_public_path__ + "static/media/Product_in_shop.0a042e8b370adbdb54fbbaf291cb2661.svg";
export { ForwardRef as ReactComponent };